export default function MobileBurger({open, setOpen}) {    
    const moveMenu = () => {
        setOpen(prev => !prev)
    };
    return (
        <button onClick={moveMenu} className="mobile-burger">
            <span/>
            <span/>
            <span/>
        </button>
    )
}